import { createSlice } from '@reduxjs/toolkit'


const snackbarSlice = createSlice({
    name: 'snackbar',
    initialState: {
        snackbar_vals: {
            showSnackbar: false,
            message: '',
            status: 'info'
        }
    },
    reducers: {
        setSnackbar(state, {payload}){
            state.snackbar_vals.showSnackbar = true;
            state.snackbar_vals.message = payload.message;
            state.snackbar_vals.status = payload.status;
            // console.log('---snackbarSlice---setSnackbar:', payload)
        },

        closeSnackbar(state) {
            state.snackbar_vals.showSnackbar = false;
            state.snackbar_vals.color = 'gray';
            state.snackbar_vals.message = '';
        },

        updateSnackbar(state, {payload}) {
            state.snackbar_vals = { ...payload }
        },

    }
});


export default snackbarSlice.reducer;
export const { setSnackbar, closeSnackbar, updateSnackbar } = snackbarSlice.actions;
